// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Themes */
.theme--light.v-sheet {
  background-color: #fff;
  border-color: #fff;
  color: rgba(0,0,0,0.87);
}
.theme--dark.v-sheet {
  background-color: #424242;
  border-color: #424242;
  color: #fff;
}
.v-sheet {
  display: block;
  border-radius: 2px;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.v-sheet--tile {
  border-radius: 0;
}
`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/src/stylus/components/_sheet.styl","webpack://./node_modules/vuetify/src/stylus/theme.styl"],"names":[],"mappings":"AAGA,WAAA;ACIE;EDFA,sBAA4B;EAC5B,kBAAwB;EACxB,uBAAsB;AAFxB;ACME;EDNA,yBAA4B;EAC5B,qBAAwB;EACxB,WAAsB;AAGxB;AACA;EACE,cAAS;EACT,kBAAe;EACf,kBAAU;EACV,gDAAY;AACd;AACE;EACE,gBAAe;AACnB","sourcesContent":["@import '../bootstrap'\n@import '../theme'\n\n/* Themes */\nv-sheet($material)\n  background-color: $material.cards\n  border-color: $material.cards\n  color: $material.text.primary\n\ntheme(v-sheet, \"v-sheet\")\n\n.v-sheet\n  display: block\n  border-radius: $sheet-border-radius\n  position: relative\n  transition: $primary-transition\n\n  &--tile\n    border-radius: 0\n","@import './settings/_theme.styl'\n\ntheme($component, $name)\n  light($component, $name)\n  dark($component, $name)\n\nlight($component, $name)\n  .theme--light.{$name}\n    $component($material-light)\n\ndark($component, $name)\n  .theme--dark.{$name}\n    $component($material-dark)\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
